/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/components/NextPlaylistContentOverview.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { NavMarker } from 'react-rhumb';
import LessonOverviewModalContainer from 'academy-common-lib/features/overview/containers/LessonOverviewModalContainer';
import TrackOverviewModalContainer from 'academy-common-lib/features/overview/containers/TrackOverviewModalContainer';
import { ACRedirect } from 'academy-common-lib/components/ACRedirect';
import { NextPlaylistContent } from './NextPlaylistContent.migrated';
import { usePlaylistIdFromSearch } from '../hooks.migrated';
import { getShortContentUrl } from '../../shortContent/shortContentRouting.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/components/NextPlaylistContentOverview.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const NextPlaylistContentOverview = ({
  trackId,
  lessonId,
  shortId,
  navMarkerName
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const content = /*#__PURE__*/_jsx(NextPlaylistContent, {
    lessonId: lessonId,
    render: ({
      trackId: nextTrackId,
      lessonId: nextLessonId,
      shortId: nextShortId,
      language: nextItemLanguage
    }) => {
      if (!nextTrackId && !nextLessonId && !nextShortId) return null;

      // Skip the overview modal in playlist context — go straight to next content
      if (playlistId) {
        if (nextShortId) {
          return /*#__PURE__*/_jsx(ACRedirect, {
            to: getShortContentUrl({
              shortId: nextShortId,
              playlistId
            })
          });
        }
        return /*#__PURE__*/_jsx(ACRedirect, {
          to: {
            pathname: nextTrackId ? `/tracks/${nextTrackId}` : `/lessons/${nextLessonId}`,
            search: `?language=${nextItemLanguage.toUpperCase()}&playlistId=${playlistId}`
          }
        });
      }
      if (nextTrackId) {
        return /*#__PURE__*/_jsx(TrackOverviewModalContainer, {
          isPlaylistOverview: true,
          language: nextItemLanguage,
          trackId: nextTrackId
        });
      } else if (nextLessonId) {
        return /*#__PURE__*/_jsx(LessonOverviewModalContainer, {
          isPlaylistOverview: true,
          language: nextItemLanguage,
          lessonId: nextLessonId
        });
      }
      return null;
    },
    shortId: shortId,
    trackId: trackId
  });
  if (navMarkerName) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName,
      children: content
    });
  }
  return content;
};